import {remove, update, useActions, useGetters, useMutators, useState} from './_map';

import {MAP_OBJECT_TYPE_GEOFENCE} from "@/js/constants";
import axios from "axios";
import useOptimizedList from "@/js/Store/_optimizedList.js";
export default {
    namespaced: true,
    state: {
        ...useState(),
        params: { grouped: 1 },
        name: MAP_OBJECT_TYPE_GEOFENCE,
        listMap: {},
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
        ...useOptimizedList(update, remove),
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/geofence/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
    },
}